import React from 'react';
import PolicyPage from './PolicyPage';
import usoResponsavel from './content/usoResponsavel';

const UsoResponsavel = () => (
    <PolicyPage
        titulo="Política Geral de Uso Responsável da Empiria"
        versao="Versão publicada no dia 23 de julho de 2026"
        blocos={usoResponsavel}
    />
);

export default UsoResponsavel;
